import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  paper: {
    borderRadius: 3,
    background: '#0f141c',
    color: '#fff',
    position: 'relative',
  },
  title: {
    fontWeight: 600,
    color: '#fff',
    paddingRight: '48px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingTop: '4px',
  },
  metaRow: {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap' as const,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 1.5,
    borderRadius: 1,
    background: '#141a24',
    border: '1px solid #1f2a3a',
  },
  metaLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    minWidth: 220,
    flex: '1 1 auto',
  },
  metaRight: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    minWidth: 220,
    flex: '1 1 auto',
    alignItems: 'flex-start',
  },
  metaLabel: {
    color: '#9fb4d1',
    fontSize: 12,
    textTransform: 'uppercase' as const,
    letterSpacing: 0.6,
  },
  metaValue: {
    color: '#d9e1f1',
    fontSize: 14,
    fontWeight: 600,
    wordBreak: 'break-all' as const,
  },
  layout: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '1.15fr 0.85fr' },
    gap: 2,
    alignItems: 'start',
  },
  panel: {
    padding: 1.5,
    borderRadius: 1,
    background: '#141a24',
    border: '1px solid #1f2a3a',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
    minHeight: 0,
  },
  panelTitle: {
    color: '#d9e1f1',
    fontWeight: 700,
  },
  panelSubtitle: {
    color: '#9fb4d1',
    fontSize: 13,
    marginTop: -0.5,
  },
  dropZone: {
    border: '1px dashed #2d384a',
    borderRadius: 2,
    padding: 3,
    textAlign: 'center' as const,
    background: '#0f141c',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  dropZoneActive: {
    borderColor: COLORS.MYTAVERSE_BLUE,
    background: '#142033',
  },
  dropZoneTitle: {
    color: '#fff',
    marginTop: 1,
  },
  dropZoneSubtitle: {
    color: '#aeb7c7',
    marginTop: 0.5,
    marginBottom: 1,
  },
  selectButton: {
    marginTop: 1.5,
    textTransform: 'none' as const,
  },
  uploadIcon: {
    fontSize: 40,
    color: COLORS.MYTAVERSE_BLUE,
  },
  fileRow: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 1,
    padding: 1,
    borderRadius: 1,
    background: '#0f141c',
    border: '1px solid #1f2a3a',
  },
  fileName: {
    color: '#d9e1f1',
    fontSize: 13,
    fontWeight: 600,
    wordBreak: 'break-all' as const,
    flex: '1 1 auto',
  },
  fileMeta: {
    color: '#9fb4d1',
    fontSize: 12,
    whiteSpace: 'nowrap' as const,
  },
  previewImage: {
    width: '100%',
    maxHeight: 240,
    objectFit: 'contain' as const,
    borderRadius: 8,
    background: '#0e121a',
  },
  unrealFrame: {
    width: '100%',
    maxWidth: 520,
    borderRadius: 1.5,
    border: '1px solid #2d384a',
    backgroundColor: '#0f141c',
    overflow: 'hidden',
    position: 'relative' as const,
    margin: '0 auto',
    backgroundImage:
      'linear-gradient(45deg, rgba(255,255,255,0.06) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.06) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.06) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.06) 75%)',
    backgroundSize: '24px 24px',
    backgroundPosition: '0 0, 0 12px, 12px -12px, -12px 0px',
  },
  zoomButton: {
    position: 'absolute' as const,
    top: 8,
    right: 8,
    zIndex: 2,
    backgroundColor: 'rgba(15, 20, 28, 0.75)',
    border: '1px solid #2d384a',
    color: '#d9e1f1',
    '&:hover': {
      backgroundColor: 'rgba(20, 32, 51, 0.85)',
    },
  },
  unrealImage: {
    width: '100%',
    height: '100%',
    display: 'block',
    background: '#0e121a',
  },
  unrealPlaceholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    textAlign: 'center' as const,
  },
  unrealPlaceholderTitle: {
    color: '#d9e1f1',
    fontWeight: 700,
  },
  unrealPlaceholderText: {
    color: '#9fb4d1',
    fontSize: 13,
    marginTop: 0.5,
  },
  previewMetaRow: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: 1.5,
    justifyContent: 'space-between',
  },
  previewMetaText: {
    color: '#9fb4d1',
    fontSize: 12,
  },
  aspectWarning: {
    color: '#ffd38a',
    fontSize: 12,
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    marginTop: 1,
  },
  statusText: {
    color: '#d9e1f1',
  },
  previewRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    marginTop: 1,
    padding: 1.5,
    borderRadius: 1,
    background: '#141a24',
    border: '1px solid #1f2a3a',
  },
  previewText: {
    color: '#9fb4d1',
    wordBreak: 'break-all' as const,
    fontSize: 13,
  },
  errorText: {
    marginTop: 1,
    color: COLORS.RED,
  },
  actions: {
    padding: '0 24px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
  },
  closeButton: {
    position: 'absolute' as const,
    top: 8,
    right: 8,
    color: '#fff',
  },
  cancelButton: {
    textTransform: 'none' as const,
    color: '#d9e1f1',
  },
  confirmButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    minWidth: 140,
  },
  zoomPaper: {
    borderRadius: 3,
    background: '#0f141c',
    color: '#fff',
  },
  zoomTitle: {
    fontWeight: 700,
    color: '#fff',
    paddingRight: '48px',
  },
  zoomContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingTop: 0,
  },
  zoomMetaRow: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: 1.5,
    justifyContent: 'space-between',
    padding: 1.25,
    borderRadius: 1,
    background: '#141a24',
    border: '1px solid #1f2a3a',
  },
  zoomFrameWrap: {
    display: 'flex',
    justifyContent: 'center',
  },
  zoomFrame: {
    maxWidth: 'min(1200px, 100%)',
  },
});

